<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <CategoriesFilter
                :default-range="defaultRange"
                :filter-errors="filterErrors"
                :disabled="disablePagination"
            />
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Categories table</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            data-toggle="tooltip"
                            data-widget="collapse"
                            title="Collapse"
                            type="button"
                        >
                            <i class="fa fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- /.box-header -->
                <div
                    v-if="categories.last_page > 1"
                    class="box-body with-border clearfix"
                >
                    <div
                        class="pagination-box"
                        @click="preventEnter"
                        @keydown="preventEnter"
                    >
                        <pagination
                            :class="isDisabled()"
                            :data="categories"
                            :limit="$root.paginator.settings.limit"
                            :size="$root.paginator.settings.size"
                            class="pull-right no-margin vue-pagination"
                            show-disabled
                            @pagination-change-page="changePage"
                        >
                            <span slot="prev-nav">
                                <i class="fa fa-angle-double-left"></i>
                            </span>
                            <span slot="next-nav">
                                <i class="fa fa-angle-double-right"></i>
                            </span>
                        </pagination>
                    </div>
                </div>
                <div
                    v-if="!categories"
                    class="box-body"
                >
                    <p>There are no Categories in the system.</p>
                </div>
                <div
                    v-else
                    class="box-body table-responsive no-padding"
                >
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Group</th>
                                <th>Lists</th>
                                <th>Contacts</th>
                                <th>Statistic</th>
                                <th class="text-right">Created At</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="category in categories.data">
                                <tr
                                    v-if="!category.removed"
                                    :key="category.id"
                                >
                                    <td>{{ category.id }}</td>
                                    <td>{{ category.name }}</td>
                                    <td>
                                        <a
                                            v-if="category.group"
                                            :href="getRoute(category.group.id, 'group')"
                                            :title="category.group.name"
                                            >{{ category.group.name }}</a
                                        >
                                    </td>
                                    <td class="text-left">
                                        <img
                                            v-show="!isLoaded"
                                            alt="Preloader"
                                            class="table-row-preloader"
                                            rel="preload"
                                            src="/img/table-row-preloader.gif"
                                        />
                                        <BadgeTotal
                                            v-show="isLoaded"
                                            :value="category.lists_count"
                                            color="gray"
                                            title="Total"
                                        />
                                        <BadgeTotal
                                            v-show="isLoaded"
                                            :value="category.lists_active"
                                            color="green"
                                            title="Active"
                                        />
                                        <BadgeTotal
                                            v-show="isLoaded"
                                            :value="category.lists_inactive"
                                            color="red"
                                            title="Inactive"
                                        />
                                    </td>
                                    <td>
                                        <img
                                            v-show="!isLoaded"
                                            alt="Preloader"
                                            class="table-row-preloader"
                                            rel="preload"
                                            src="/img/table-row-preloader.gif"
                                        />
                                        <BadgeTotal
                                            v-show="isLoaded"
                                            :value="category.contacts_count"
                                            color="gray"
                                            title="Total"
                                        />
                                        <BadgeTotal
                                            v-show="isLoaded"
                                            :value="category.contacts_active"
                                            color="green"
                                            title="Active"
                                        />
                                        <BadgeTotal
                                            v-show="isLoaded"
                                            :value="category.contacts_inactive"
                                            color="red"
                                            title="Inactive"
                                        />
                                    </td>
                                    <td>
                                        <img
                                            v-show="!isLoaded"
                                            alt="Preloader"
                                            class="table-row-preloader"
                                            rel="preload"
                                            src="/img/table-row-preloader.gif"
                                        />
                                        <ListItemsBadges
                                            v-show="isLoaded"
                                            :rows="staticsRowData(category)"
                                            :sizable="true"
                                        />
                                    </td>
                                    <td class="text-right">{{ category.created_at }}</td>
                                    <td class="text-right">
                                        <span v-if="editAvailable">
                                            <ModalListsContent
                                                v-if="deleteAvailable && category.total_lists_count === 0"
                                                :id="category.id"
                                                :modal="modal"
                                                :route="route"
                                                type="delete"
                                                @click="isShowModal = true"
                                                @modalEmitData="emittedModalData"
                                            />
                                            <a
                                                :href="getRoute(category.id, 'edit')"
                                                class="btn btn-sm btn-primary"
                                            >
                                                <i class="fa fa-edit"></i>
                                                <span class="sr-only">Edit</span>
                                            </a>
                                        </span>
                                        <a
                                            :href="getRoute(category.id, 'show')"
                                            class="btn btn-sm btn-info"
                                        >
                                            <i class="fa fa-eye"></i>
                                            <span class="sr-only">Show</span>
                                        </a>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <div class="box-footer clearfix">
                    <div
                        v-if="categories.total"
                        class="with-border clearfix"
                    >
                        <div
                            class="pagination-box"
                            @click="preventEnter"
                            @keydown="preventEnter"
                        >
                            <pagination
                                :class="isDisabled()"
                                :data="categories"
                                :limit="$root.paginator.settings.limit"
                                :size="$root.paginator.settings.size"
                                class="pull-right no-margin vue-pagination"
                                show-disabled
                                @pagination-change-page="changePage"
                            >
                                <span slot="prev-nav">
                                    <i class="fa fa-angle-double-left"></i>
                                </span>
                                <span slot="next-nav">
                                    <i class="fa fa-angle-double-right"></i>
                                </span>
                            </pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <main-modal-form
            v-if="isShowModal"
            :modal="emittedModalValues"
            @close="isShowModal = false"
            @updateData="modalData($event)"
        />
    </div>
</template>

<script>
import BadgeTotal from '../../subcomponents/BadgeTotal';
import ListItemsBadges from '../../subcomponents/ListItemsBadges';
import ModalListsContent from '../../subcomponents/modals-content/ModalListsContent';
import CategoriesFilter from './CategoriesFilter';
import FilterRange from '../../../configs/filter-data-selector-range';
import DateRangeMixin from '../../mixins/date-range-mixin';

export default {
    components: {
        ModalListsContent,
        BadgeTotal,
        ListItemsBadges,
        CategoriesFilter,
    },
    mixins: [DateRangeMixin],
    data: function () {
        return {
            filterErrors: '',
            defaultRange: FilterRange.MONTH,
            categories: {},
            stats: {},
            ids: [],
            isLoaded: false,
            disablePagination: true,
            editAvailable: false,
            deleteAvailable: false,
            pageNumber: this.$route.query.page,
            isShowModal: false,
            emittedModalValues: {},
            modal: {
                class: 'modal-lists',
                header: this.$t('listCategory.modal.header'),
                body: this.$t('listCategory.modal.body'),
                isBodyHtml: true,
                id: '',
                active: '',
            },
            route: {
                show: this.$route.path + '/:id:/show',
                edit: this.$route.path + '/:id:/edit',
                delete: this.$route.path + '/:id:/delete',
                group: '/category-groups/:id:',
            },
        };
    },
    computed: {
        filter() {
            let params = [];

            if (this.$route.query['filter[dates]']) {
                params.push('filter[dates]=' + this.$route.query['filter[dates]']);
            } else if (this.defaultRange) {
                let [startDate, endDate] = this.getDefaultRangeDates();
                params.push('filter[dates]=' + moment(startDate).format('YYYY-MM-DD') + ' - ' + moment(endDate).format('YYYY-MM-DD'));
            }

            return params.length ? '&' + encodeURI(params.join('&')) : '';
        },
    },
    watch: {
        '$route.query': {
            handler() {
                this.clearErrors();
                this.getData(this.$route.query.page || 1);
            },
            deep: true,
        },
    },
    mounted() {
        this.getData(this.pageNumber);
    },
    methods: {
        clearErrors: function () {
            this.filterErrors = '';
        },
        emittedModalData(value) {
            this.emittedModalValues = value;
        },
        modalData: function (e) {
            this.modalNewData = e;
            this.isShowModal = false;
            _.merge(_.keyBy(this.categories.data, 'id'), _.keyBy({ 0: this.modalNewData }, 'id'));
        },
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        getData(page = 1) {
            this.disablePagination = true;

            let url = '/lists/categories/data?page=' + page;

            if (this.$route.query['filter[search]']) {
                url += '&filter[search]=' + encodeURIComponent(this.$route.query['filter[search]']);
            }

            axios.get(url).then((response) => {
                this.isLoaded = false;
                this.categories = response.data.categories;
                this.editAvailable = response.data.editAvailable;
                this.deleteAvailable = this.categories.total > 1;
                this.ids = response.data.ids;

                if (!this.ids || this.ids.length === 0) {
                    this.stats = {};
                    this.isLoaded = true;
                    this.disablePagination = false;
                    return;
                }

                this.getStats(this.ids);
            });
        },
        changePage(page) {
            let query = { ...this.$route.query, page: String(page) };

            this.$router.push({
                path: this.$route.path,
                query,
            }).catch(() => {});
        },
        getStats(ids) {
            axios
                .get('/lists/categories/stats?ids=' + ids + this.filter)
                .then((response) => {
                    this.stats = response.data.stats;
                    this.isLoaded = true;
                    this.disablePagination = false;
                    let sort = _.merge(_.keyBy(this.categories.data, 'id'), _.keyBy(this.stats, 'id'));
                    this.stats.data = _.orderBy(sort, ['id'], ['desc']);
                })
                .catch((error) => {
                    this.isLoaded = true;
                    this.disablePagination = false;
                    this.filterErrors = (error.response && error.response.data && error.response.data.errors) || 'Error fetching statistics data';
                });
        },
        staticsRowData: function (category) {
            return [
                {
                    name: 'Messages',
                    component: 'BadgeTotal',
                    items: [
                        { value: category.messages_count, title: 'Total', color: 'gray' },
                        { value: category.messages_sent, title: 'Sent', color: 'green' },
                        { value: category.messages_failed, title: 'Failed', color: 'red' },
                        { value: category.messages_blacklisted, title: 'Blacklisted', color: 'black' },
                    ],
                },
                {
                    name: 'Clicks',
                    component: 'BadgeTotal',
                    items: [
                        { value: category.percentage + '%', title: 'Percentage', color: 'light-blue' },
                        { value: category.clicks_count, title: 'Count', color: 'aqua-active' },
                    ],
                },
                {
                    name: 'Cost/Revenue',
                    component: 'BadgeTotal',
                    items: [
                        { value: '$' + category.messages_cost, title: 'Costs', color: 'yellow' },
                        { value: '$' + category.revenues_prepared_value, title: 'Revenue', color: 'light-blue' },
                        { value: category.revenues_count, title: 'Count', color: 'aqua-active' },
                    ],
                },
                {
                    name: 'pCPM/eCPM/EPC',
                    component: 'BadgeTotal',
                    items: [
                        {
                            value: category.pcpm_prepared_value,
                            title: 'pCPM',
                            color: 'green',
                            convertNegative: true,
                            symbol: '$',
                        },
                        { value: category.ecpm_prepared_value, title: 'eCPM', color: 'light-blue' },
                        { value: category.epc_prepared_value, title: 'EPC', color: 'aqua-active' },
                    ],
                },
                {
                    name: 'Unsubscribes',
                    component: 'BadgeTotal',
                    items: [
                        { value: category.unsubscribes_percent + '%', title: 'Percentage', color: 'light-blue' },
                        { value: category.unsubscribes_count, title: 'Count', color: 'aqua-active' },
                    ],
                },
            ];
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
    },
};
</script>
